module.exports = {
  attach: function() {
        const $cartPage = $('.cart-page');
        const $cart = $('#gtm-cart-products');

        if ($cartPage.is('*') && $cart.is('*')) {
            const gtmProducts = $cart.attr('data-gtm-products');
            const gtmDetails = $cart.attr('data-gtm-cartdetails');
            const data = { gtmProducts, gtmDetails } ;
            $('.checkout-btn').on('click', function (e) {
                e.preventDefault();
                $('body').trigger('gtm:ga4:startCheckout', data);
                if ($(this).data('login-customer')) {
                  let url = $('#nextStepUrl').data('next-step-url');
                  if (!url || url === '') {
                    url = $('.checkout-btn').attr('href');
                  }

                  window.location.href = url;
                }
          });
      }
  }
}